import {Authenticator} from "@aws-amplify/ui-react";
import React from "react";
import {AppRoutes} from "./routing/AppRoutes";

function App() {
  return <>
    <Authenticator.Provider>
      <AppRoutes />
    </Authenticator.Provider>
  </>
}

export default App;
